import React, { useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import Fuse from "fuse.js";
import "../../../css/Views/HelpView.css";
import { helpArticles } from "./HelpArticles";

const normalize = (s) =>
  (s ?? "")
    .toLowerCase()
    .replace(/[ąĄ]/g, "a")
    .replace(/[ćĆ]/g, "c")
    .replace(/[ęĘ]/g, "e")
    .replace(/[łŁ]/g, "l")
    .replace(/[ńŃ]/g, "n")
    .replace(/[óÓ]/g, "o")
    .replace(/[śŚ]/g, "s")
    .replace(/[żŻ]/g, "z")
    .replace(/[źŹ]/g, "z");

const HelpView = () => {
  const [query, setQuery] = useState("");
  const navigate = useNavigate();

  const normalizedArticles = useMemo(() => {
    return helpArticles.map((a) => ({
      ...a,
      titleNorm: normalize(a.title),
      summaryNorm: normalize(a.summary),
    }));
  }, []);

  const fuse = useMemo(() => {
    return new Fuse(normalizedArticles, {
      threshold: 0.3,
      ignoreLocation: true,
      keys: [
        { name: "titleNorm", weight: 0.7 },
        { name: "summaryNorm", weight: 0.3 },
      ],
    });
  }, [normalizedArticles]);

  const results = useMemo(() => {
    const q = normalize(query.trim());
    if (!q) return normalizedArticles;

    return fuse.search(q).map((r) => r.item);
  }, [query, fuse, normalizedArticles]);

  const orderedResults = useMemo(() => {
    const list = results.slice();
    list.sort((a, b) => (b.isPinned === true) - (a.isPinned === true));
    return list;
  }, [results]);

  return (
    <div className="bank-transfers-view">
      <div className="bank-header">Poradnik systemowy</div>

      <div className="participant-search-bar">
        <input
          type="text"
          placeholder="Szukaj (np. korekta, zaliczka, saldo...)"
          value={query}
          onChange={(e) => setQuery(e.target.value)}
          className="search-input"
        />
      </div>

      {orderedResults.length === 0 && (
        <div className="help-empty">Brak wyników</div>
      )}

      <div className="help-tiles">
        {orderedResults.map((a) => (
          <div
            key={a.id}
            className={`help-tile ${a.isPinned ? "pinned" : ""}`}
            onClick={() => navigate(`article/${a.id}`)}
          >
            {a.isPinned && (
              <div className="help-tile-star" title="Przypięte">
                📌
              </div>
            )}

            <div className="help-tile-title">{a.title}</div>

            {a.summary && (
              <div className="help-tile-desc">{a.summary}</div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default HelpView;